import usePrivateAxios from '@/common/api/usePrivateAxios'
import { transformUpdatedProductCategory } from '@/features/governmentAllocations/pages/Update/utils/transformNewProductCategories'
import { GovernmentAllocationEntryProductCategoryCurrencyValidationSchema, GovernmentAllocationEntryProductCategoryQuantityValidationSchema } from '@/features/governmentAllocations/schemas/update.schema'
import { GovernmentAllocationEntryProductCategory } from '@/features/governmentAllocations/types/governmentAllocationEntry.type'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseUpdateGovernmentAllocationEntryProductCategoryProps = {
  governmentAllocationId: string
  entryProductCategory: GovernmentAllocationEntryProductCategory
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useUpdateGovernmentAllocationEntryProductCategory = ({
  governmentAllocationId,
  entryProductCategory,
  onSuccess,
  onError,
}: UseUpdateGovernmentAllocationEntryProductCategoryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateGovernmentAllocationEntryProductCategory'],
    mutationFn: async (form: GovernmentAllocationEntryProductCategoryCurrencyValidationSchema | GovernmentAllocationEntryProductCategoryQuantityValidationSchema) => {
      const government_allocation_entry = {
        entry_product_categories_attributes: [transformUpdatedProductCategory(form, entryProductCategory)],
      }

      return privateAxios.put(`/billing/government_allocation_entries/${governmentAllocationId}`, {
        government_allocation_entry,
      })
    },
    onSuccess,
    onError,
  })
}
